/**
 * Character slug mapping for URL-friendly character names to model IDs
 * This JavaScript mapping mirrors the Python character_mapping.py file
 */

// Map model IDs to their primary URL slugs
export const CHARACTER_ID_TO_SLUG = {
    // Scientists & Inventors
    "bc5d31a8-047b-4f72-8f16-fea7a365ca69": "feynman",
    "d537d61d-0313-421b-ae66-48a8d7222b3f": "tesla",
    "16f5b6a1-45f6-4c01-a612-60d4e4ab2297": "rene",
    "5eb1ad8d-4c11-4174-b79a-c232991d015b": "oppenheimer",
    "897eb00c-4f16-4f73-81d5-d1c91fad53f2": "darwin",
    "278dddd6-b4a8-4303-a41d-be6219dbc907": "einstein",
    "8944783c-2e2b-4796-b92e-21dacca776bc": "leonardo",
    "73f610bf-d9c9-4d9f-a026-a10086a66725": "curie",
    "802bd089-d231-4c4e-830c-476199321af8": "bohr",
    "d6e3a3f1-d31e-4aab-8dd0-8b820932bd13": "fermi",
    "93ea7051-9722-443d-90fb-18a84c51894c": "maxwell",
    "7021ffd6-51bb-41a8-920e-935899dcd631": "newton",
    "be0dcf0f-c72b-48f7-a462-6ba7560498d7": "turing",

    // Historical Figures
    "770e2d93-a6a4-41ed-aca1-8951327885b5": "earhart",
    "031f2eea-64e5-441d-a37d-03d260cc43dc": "lincoln",
    "e3f55c33-3ff0-471f-b833-b59d7b145fc6": "capone",
    "9ef81498-3fb9-4175-a6d4-c2a02d71c640": "cyrus",
    "8f109c00-f7d2-4b9b-b44e-740a55e4339e": "washington",
    "3f14429d-b2d4-4b99-8a05-58eed567c0d3": "mansa",
    "581e7293-43cf-45ea-9fb3-0955c563cbe2": "khan",
    "5a16ff56-6e03-414e-a89d-cda9d83fae60": "ford",

    // Business & Economics
    "a59fe2c1-9046-405a-9a99-a7ddbaee13be": "smith",
    "7c7ac397-c36e-4218-92d4-f437d1959cca": "euclid",
    "f9f3f836-00c6-4160-8416-4b71b53f1307": "ramanujan",
    "5802e813-e715-491d-a0fd-92dc643c458e": "pascal",
    "191e6103-a42c-4132-926c-230e7b1be5b6": "bernoulli",
    "6bcf3678-e232-46c9-996a-67beb3fd2dbf": "khwarizmi",
    "14836d13-ace6-4bf8-be26-26fbb80ed9bc": "socrates",
    "3841a6bb-f977-453d-92f5-6cec1267546f": "freud",
    "c0063a05-916b-45d0-bc2c-c63210414b17": "ada",
    "7f61d092-99e4-48e6-bf80-7aa2b7bd98ff": "gauss",
    "127cd993-f16e-4659-84fa-882cba633097": "galileo",
    "94b6efbe-0aaa-47c7-bd3f-6d4f441d767f": "hopper",
    "c93478a1-ed2f-4f1a-81f6-3fa474a21566": "lagrange",
    "5a39bed2-a551-4a03-98a2-46104a3324bf": "euler",
    "2707ca40-df64-4258-97c8-67d3695e8a42": "brahmagupta",
    "e617290b-bda0-4771-91ac-3fe6939dd412": "franklin",
    "a2a43496-9a83-4444-813e-18a1930296e6": "khayyam",
    "78376372-3d71-4fce-8650-82b5be2c006b": "diophantus",
    "ca6ebdca-5151-4a58-8523-56d25fce5dfa": "playfair",
    "e3428624-bd1e-48b9-ae8c-c66ba68879cc": "boole",
    "3140d634-c7ca-4bda-af36-e1b49978b201": "bayes",
    "c73fed54-81e3-46ec-9d7c-3d11d05b142d": "eratosthenes",
    "ece0ab37-37c1-4ead-8222-fbb5b185dbe2": "volta",
    "d13b5a81-ed77-4a25-8a01-a76a0165b349": "archimedes",
    "2db1d398-0161-46cd-8aff-53008d29a9dc": "shannon",
    "8f67d579-41c2-456d-900b-fccbcbf46bd3": "viete",
    "ec6c5b20-8ac6-42bd-b291-f248cb3f0ebc": "klein",
    "44f87c0b-ca22-4225-9fea-8d823e6a0160": "buffett",
    "548fe879-e63c-4d6c-a377-525f4f9e12c8": "satoshi",

    // Writers & Artists
    "b20dc26f-8924-4aee-9ef5-9b98c0367a34": "hemingway",
    "992e9007-b4f8-4711-80c2-884daf3d9960": "vangogh",
    "4f50a698-6034-49c1-b9d4-221f59bf2378": "kahlo",
    "d75e63e0-2b2b-43ef-933f-589e8d6818c0": "dali",
    "59c67a42-8c1e-45b8-aa41-b6fe6b3f5629": "orwell",
    "4d7d2e17-b818-4144-b78b-629c688a71ac": "marx",

    // Philosophers
    "c4b9ac58-a66a-451e-b035-afabd8be50b9": "aristotle",
    "b8951237-698b-42b5-8b6e-ee381b91fb65": "confucius",
    "e97568c5-1daa-4a95-b4ae-0fe374c6b083": "marcus",
    "3542f19e-4e07-4828-8f9d-f330e4d6d660": "plato",
    "5a42d57c-6e2b-4ba8-bd32-838a1a5c5e6b": "machiavelli",
    "88c314c4-5890-4e55-9418-8b46a376ef81a": "nietzsche",
    "91d5cec5-1c21-423f-bbb4-bceb0f77a6c9": "nostradamus",

    // Civil Rights Leaders
    "2baa0479-7e38-4473-a2f2-1ad54149dbac": "ali",
    "9039a447-b6eb-4de2-9927-0b0c6476c090": "malcolm",
    "d0c97034-328e-4538-8107-a9825d0c1594": "mlk",
};

// Reverse mapping for quick lookups
export const SLUG_TO_CHARACTER_ID = Object.entries(CHARACTER_ID_TO_SLUG).reduce(
    (acc, [id, slug]) => {
        acc[slug] = id;
        return acc;
    },
    {},
);

/**
 * Get the URL slug for a given model ID
 * @param {string} modelId - The model UUID
 * @returns {string|null} - The character slug or null if not found
 */
export function getSlugForModelId(modelId) {
    if (CHARACTER_ID_TO_SLUG[modelId]) return CHARACTER_ID_TO_SLUG[modelId];
    // Doc-born characters (character_documents control plane, Task #413)
    try {
        const d = (window.__docCharacters || {})[modelId];
        if (d && d.slug) return d.slug;
    } catch (e) {}
    return null;
}

/**
 * Get the model ID for a given URL slug
 * @param {string} slug - The URL slug
 * @returns {string|null} - The model UUID or null if not found
 */
export function getModelIdForSlug(slug) {
    if (SLUG_TO_CHARACTER_ID[slug]) return SLUG_TO_CHARACTER_ID[slug];
    // Doc-born characters (character_documents control plane, Task #413) —
    // registry slugs always win; a document can never shadow a shipped one.
    try {
        const docs = window.__docCharacters || {};
        for (const id in docs) {
            if (docs[id] && docs[id].slug === slug) return id;
        }
    } catch (e) {}
    return null;
}

/**
 * Build the proper lab URL for a character
 * @param {string} modelId - The model UUID
 * @returns {string} - The full URL path to the character's lab page
 */
export function getLabUrlForModel(modelId) {
    const slug = getSlugForModelId(modelId);
    if (slug) {
        return `/lab/${slug}`;
    }
    // Fallback to query parameter if slug not found
    return `/lab?character=${modelId}`;
}
